function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.75 48C38.0048 48 48.75 37.2548 48.75 24C48.75 10.7452 38.0048 0 24.75 0C11.4952 0 0.75 10.7452 0.75 24C0.75 37.2548 11.4952 48 24.75 48Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_1080:51777)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M33.444 15.6001H23.5513C22.0118 15.6001 20.7248 16.66 20.3462 18.0733H16.7879C14.567 18.0733 12.75 19.8903 12.75 22.1111V25.3162C12.75 27.537 14.567 29.354 16.7879 29.354H16.8636L16.5102 30.8935C16.4345 31.1963 16.5102 31.4991 16.6869 31.7263C16.8636 31.9534 17.1664 32.1048 17.4692 32.1048C17.6459 32.1048 17.8478 32.0544 17.9992 31.9534L22.1128 29.354H26.7058C28.4219 29.354 29.8856 28.2689 30.4661 26.7547L32.6364 28.1427C32.8383 28.2689 33.0907 28.0922 33.0402 27.8651L32.4598 25.4171H33.444C35.261 25.4171 36.75 23.9282 36.75 22.1111V18.9061C36.75 17.0891 35.261 15.6001 33.444 15.6001ZM30.0118 25.3162C30.0118 25.6695 29.9613 26.0228 29.8352 26.3509C29.4061 27.6632 28.1696 28.6222 26.7058 28.6222H21.9109L17.6207 31.3477C17.5702 31.373 17.5197 31.3982 17.4692 31.3982C17.3178 31.3982 17.1664 31.2468 17.2169 31.0701L17.7973 28.6222H16.8131C14.9961 28.6222 13.5071 27.1332 13.5071 25.3162V22.1111C13.5071 20.2941 14.9961 18.8051 16.8131 18.8051H26.7058C28.5229 18.8051 30.0118 20.2941 30.0118 22.1111V25.3162Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.7059 24.6098C19.2076 24.6098 19.6144 24.203 19.6144 23.7013C19.6144 23.1995 19.2076 22.7927 18.7059 22.7927C18.2041 22.7927 17.7974 23.1995 17.7974 23.7013C17.7974 24.203 18.2041 24.6098 18.7059 24.6098Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.7596 24.6098C22.2613 24.6098 22.6681 24.203 22.6681 23.7013C22.6681 23.1995 22.2613 22.7927 21.7596 22.7927C21.2578 22.7927 20.8511 23.1995 20.8511 23.7013C20.8511 24.203 21.2578 24.6098 21.7596 24.6098Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.7879 24.6098C25.2897 24.6098 25.6964 24.203 25.6964 23.7013C25.6964 23.1995 25.2897 22.7927 24.7879 22.7927C24.2861 22.7927 23.8794 23.1995 23.8794 23.7013C23.8794 24.203 24.2861 24.6098 24.7879 24.6098Z",
  fill: "black"
}));

var SvgChat = function SvgChat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M48.25 24C48.25 36.9787 37.7287 47.5 24.75 47.5C11.7713 47.5 1.25 36.9787 1.25 24C1.25 11.0213 11.7713 0.5 24.75 0.5C37.7287 0.5 48.25 11.0213 48.25 24Z",
    fill: "white",
    style: {
      stroke: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1080:51777",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 48
  }, _ref2), _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat.ec36caed.svg";
export { ForwardRef as ReactComponent };